import React from 'react';
import styles from './BtnsActionsTenant.module.scss';
import { texts } from '../../../constants/texts';
import { Icon } from 'antd';

const BtnsActionsTenant = ({
  onChangeButtonClick,
  handleDeleteTenant,
  isLoadingDelete,
}) => {
  return (
    <div className={styles.root}>
      <div
        onClick={onChangeButtonClick}
        className={styles.btnAction}
      >{`${texts.edit}`}</div>
      <div
        onClick={handleDeleteTenant}
        className={styles.btnAction}
        style={{ color: '#F93336' }}
      >
        {isLoadingDelete ? (
          <Icon
            type="loading"
            style={{ color: '#F93336' }}
          />
        ) : (
          `${texts.delete}`
        )}
      </div>
    </div>
  );
};

export default BtnsActionsTenant;
